package com.martdev.flickq.reservation.model

enum class SeatStatus {
    AVAILABLE, HELD, BOOKED
}